import {get} from '@/lib/fetcher';

export default {
    namespaced: true,
    state: () => ({
        pairRanks: {},
        teamRanks: {},
        butlerRanks: {}
    }),
    mutations: {
        changeRanksList(state, newRanksList) {
            state.pairRanks = newRanksList.PairRanks;
            state.teamRanks = newRanksList.TeamRanks;
            state.butlerRanks = newRanksList.ButlerRanks;
        }
    },
    actions: {
        loadRankList({commit}) {
            get('/api/tournament/ranks')
                .then(resp => {
                    commit('changeRanksList', resp);
                });
        }
    },
    getters: {
        pairRanks: state => state.pairRanks,
        teamRanks: state => state.teamRanks,
        butlerRanks: state => state.butlerRanks,
    }
};
